import { motion } from 'framer-motion';

import { iconsSources } from '../../helpers/icons';
import { hideNumber } from '../../helpers/titreHelper';

import styles from './Photo.module.css';

import hum from '../../assets/images/hum.webp';

export const Photo = ({ message, rotateSign, startDutation }) => {
  const errorHandler = (e) => {
    e.target.src = iconsSources[message?.channel] || hum;
  };

  const srcAvatar =
    (message?.image !== '1' && message?.image) ||
    iconsSources[message?.channel];

  return (
    <div className={styles.photo} key={message.id}>
      <div className={styles.avatarBlock}>
        <div className={styles.avatar}>
          <div
            className={styles.avatarBg}
            style={{
              background: `url(${
                iconsSources[message?.channel]
              }) center/cover no-repeat `,
            }}
          />
          <img src={srcAvatar} alt={''} onError={errorHandler} />
        </div>

        <div className={styles.author}>
          {message?.author || hideNumber(message?.senderNumber)}
        </div>
      </div>

      <img
        src={message?.attachments[0].url}
        alt={''}
        className={styles.attach}
      />
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: [0, 0.6, 0] }}
        transition={{
          duration: startDutation,
          times: [0, 0.8, 1],
          ease: ['easeIn', 'easeOut'],
        }}
        className={styles.mask}
      />
    </div>
  );
};
